<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Profili </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_calendario_generico = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-calendar </v-icon>
          </v-btn>
        </template>
        <span>Vedi calendario generico</span>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table
      height="60vh"
      style="width: 40vw; margin:auto"
      :headers="headers_profili"
      :items="lista_profili"
      fixed-header
      class="elevation-1 pt-0"
    >
      <!-- Colonna del calendario specifico -->
      <template v-slot:[`item.cal_spec`]="{ item }">
        <v-btn
          @click="
            dialog_calendario_specifico = true;
            profilo_sel_id = item.id_profilo_utente;
          "
          small
          ><v-icon color="primary">mdi-calendar-star</v-icon></v-btn
        >
      </template>
    </v-data-table>
    <!-- DIALOG CALENDARIO GENERICO -->
    <v-dialog v-model="dialog_calendario_generico" max-width="600px">
      <CalendarioGenerico @click_chiudi="dialog_calendario_generico = false" :bottoni="true"/>
    </v-dialog>
    <!-- DIALOG CALENDARIO SPECIFICO -->
    <v-dialog v-model="dialog_calendario_specifico" max-width="800px">
      <CalendarioSpecifico
        @click_chiudi="dialog_calendario_specifico = false"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import CalendarioGenerico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioGenerico.vue";
import CalendarioSpecifico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioSpecifico.vue";

export default {
  name: "",

  components: { CalendarioGenerico, CalendarioSpecifico },

  props: [],

  data() {
    return {
      // Variabili d'appoggio
      profilo_sel_id: null,
      // Modal
      dialog_calendario_generico: false,
      dialog_calendario_specifico: false,

      // Array
      headers_profili: new Array(),
      lista_profili: new Array(),
    };
  },

  computed: {},

  watch: {},

  methods: {
    getProfili() {
      this.headers_profili = [
        {
          text: "Calendario specifico",
          value: "cal_spec",
        },
        {
          text: "Nome",
          value: "des_profilo_utente",
        },
      ];

      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getprofili",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_profili = res.data.result.profili ? res.data.result.profili : [];
            console.log(this.lista_profili);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
  },

  created() {},

  mounted() {
    this.getProfili();
  },
};
</script>

<style scoped>
</style>